export default __webpack_public_path__ + "static/media/icon-arrow-down-gray.29ffcb3b.svg";